import React from "react";
import "./contact.css";

const Contact = () => {
  return (
    <>
      <div className="contact">
        <div className="contactGroup">
          <img
            className="contactImg"
            src="https://img.delicious.com.au/cBifuvzJ/del/2016/05/baked-butter-chicken-30562-1.jpg"
          />
          <p className="contactText">
            This Indian inspired whole baked chicken is an easy way to get
            dinner on the table, whilst curing those takeaway cravings.
          </p>
          <svg
            width="512"
            height="488"
            viewBox="0 0 512 488"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M242.517 1.03121C308.172 -0.934415 375.076 10.7247 424.592 54.5185C477.34 101.171 514.224 168.316 511.896 239.281C509.624 308.529 463.475 365.634 412.861 412.139C365.198 455.931 306.718 490.344 242.517 486.786C180.974 483.376 133.24 438.62 89.8127 394.239C46.5994 350.076 3.90779 301.411 0.333397 239.281C-3.41431 174.138 24.7077 110.528 70.8775 65.1082C116.379 20.3454 179.17 2.92773 242.517 1.03121Z"
              fill="#77BCED"
              fill-opacity="0.23"
            />
          </svg>
        </div>
        <div className="contactGroup">
          <img
            className="contactImg"
            src="https://img.delicious.com.au/cBifuvzJ/del/2016/05/baked-butter-chicken-30562-1.jpg"
          />
          <p className="contactText">
            This Indian inspired whole baked chicken is an easy way to get
            dinner on the table, whilst curing those takeaway cravings.
          </p>
          <svg
            width="512"
            height="488"
            viewBox="0 0 512 488"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M242.517 1.03121C308.172 -0.934415 375.076 10.7247 424.592 54.5185C477.34 101.171 514.224 168.316 511.896 239.281C509.624 308.529 463.475 365.634 412.861 412.139C365.198 455.931 306.718 490.344 242.517 486.786C180.974 483.376 133.24 438.62 89.8127 394.239C46.5994 350.076 3.90779 301.411 0.333397 239.281C-3.41431 174.138 24.7077 110.528 70.8775 65.1082C116.379 20.3454 179.17 2.92773 242.517 1.03121Z"
              fill="#77BCED"
              fill-opacity="0.23"
            />
          </svg>
        </div>
      </div>
    </>
  );
};

export default Contact;
